<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">设置密码</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <ul>
                    <li class="item">
                        <span>账号</span>
                        <span>123456456</span>
                    </li>
                    <li class="item">
                        <span>设置密码</span>
                        <input type="text" v-model="pass" maxlength="12" minlength="6" placeholder="请输入密码">
                    </li>
                    <li class="item">
                        <span>确认密码</span>
                        <input type="text" v-model="repass" maxlength="12" minlength="6" placeholder="再次填写确认">
                    </li>
                </ul>
            </div>
            <div>
                <button class="button" @click="setPass">确认并提交</button>
            </div>
        </div>
    </div>
</template>
<script>
import { getUserPasswdAction } from "../../assets/js/api";
import { Navbar, TabItem,Toast } from 'mint-ui';
// 
export default {
  data() {
    return {  
        pass:'',    //密码
        repass:'',  //确认密码
    };
  },
  computed: {},
  components: {},
  methods: {  
      setPass(){
          var regul = /^[a-zA-Z0-9]\w{5,11}$/;
          if(regul.test(this.pass)){
              if(this.pass == this.repass){
                getUserPasswdAction(this.pass).then(res =>{
                    console.log("setPassword",res)
                    if(res.s == 0){
                        //跳转个人信息页面
                        Toast({
                            message: '密码修改成功',
                            iconClass: 'icon icon-success',
                            position: 'middle',
                            duration: 2500
                        });
                        this.$router.back();
                    }
                })
                .catch(err =>{
                    Toast:Toast({
                        message:"提交失败，请稍后重试",
                        position: 'middle',
                        duration: 2500
                    })
                });
            }else{
                Toast:Toast({
                    message:"两次输入密码不一样",
                    position: 'middle',
                    duration: 2500
                })
            }
          }else{
                Toast:Toast({
                    message:"请以字母或数字开头，长度在6~12之间，只能包含字母、数字和下划线",
                    position: 'middle',
                    duration: 2500
                })
          }
      }
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right{
    float: right;
    color: rgba(0, 0, 0,1);
    margin-top: 0.5rem;
    font-size: 0.55rem;
    margin-right: 0.6rem
}
.minContent{
    background-color: #fff;
    margin-top: 0.26rem;
}
.item{
    font-size: 0.42rem;
    color: rgba(0, 0, 0,0.7);
    line-height: 0.61rem;
    width: 94%;
    height: 0.97rem;
    margin-left: 0.61rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0,0.1);
    position: relative;
}
.item :nth-child(1){
    position: absolute;
    top: 0.2rem;
}
.item :nth-child(2){
    height: 0.68rem;
    position: absolute;
    top: 0.2rem;
    right: 0.84rem;
    color: rgba(0, 0, 0,0.5);
    border: none;
    text-align: right;
}

.button{
    width: 6.71rem;
    height: 1.05rem;
    background-color: rgba(41, 158, 173, 1);
    text-align: center;
    color: #fff;
    font-size: 0.42rem;
    border-radius: 0.16rem;
    position: relative;
    left: 15%;
    top: 0.79rem;
    border: 0.03rem solid rgba(255, 255, 255, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/mine/setPassword.vue